export const FUNNEL_STATE_ID = 'funnel_state'
export const STRICTLY_NECESSARY = 'C0001'
export const PERFORMANCE = 'C0002'
export const FUNCTIONAL = 'C0003'
export const TARGETTING = 'C0004'
export const SOCIAL_MEDIA = 'C0005'
export const USER_DATA_UPDATED_EVENT = 'userDataUpdated'
